export default {
  API_URL: "https://api.mo2.masorden.com/",
  ADMIN_API_URL: "https://admin.mo2.masorden.com/",
  GA_MEASUREMENTID: 'UA-210000501-2',
  FILE_VALIDATOR_URL: "https://gti-filevalidator.api.tress.com.mx/",
  //Cambiar el valor de URL_BUCKET_PARTICIPANTES_EJEMPLO en buildspecDeploy.yaml si se cambia aquí. Esto por motivo de deploy para ambientes bajos y PROD
  URL_BUCKET_PARTICIPANTES_EJEMPLO : "https://masorden-docs-prod.s3-us-west-2.amazonaws.com/Ejemplo%20de%20formato.csv"
}